import { render, staticRenderFns } from "./app-main.vue?vue&type=template&id=42aabae7&scoped=true&"
import script from "./app-main.vue?vue&type=script&lang=js&"
export * from "./app-main.vue?vue&type=script&lang=js&"
import style0 from "./app-main.vue?vue&type=style&index=0&id=42aabae7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42aabae7",
  null
  
)

export default component.exports